/* eslint-disable */ 
import styled from "styled-components";
import React, { forwardRef } from "react";
import keymaster from "keymaster";
import Editor from "react-ace";
import "brace/mode/pgsql";
import "brace/theme/sqlserver";
import "brace/ext/searchbox";
import { ReactSortable } from "react-sortablejs";
import Select from "react-select";
import logo_reverse from "../images/logo-hepsijet-footer.png";
import loadingIcon from "../images/ajax-loader.gif";
import { setClientDateFormat, setClientDateTimeFormat } from "../utility";
import FixedHtmlTable from "fixed-html-table";
import NumberFormat from "react-number-format";
import * as Datetime from "react-datetime";

// const StyledIcon = styled(Icon).attrs({
//     className: 'material-icons'
// })`
//     font-size: 2rem;
// `



export class DTPicker extends React.Component {
  render = function () {
    return <Datetime {...this.props} renderInput={this.renderInput} />;
  }
  renderInput = function (props, openCalendar, closeCalendar) {
    function clear() {
      props.onChange({ target: { value: '' } });
    }
    return (
      <div>
        <input {...props} disabled style={{ background: "white" }} />
        <Input_icon className="fa fa-calendar" onClick={openCalendar} />
      </div>
    );
  }
};


export const Isa = styled.div`
  margin: 10px 0px;
  // padding:12px;
`;

export const Input_icon = styled.i`
    margin-right:5px;
    margin-left:2px;
    `;

export const Isa_icon = styled.i`
    margin:10px 22px;
    font-size:2em;
    vertical-align:middle;
    `;

export const Isa_error = props => (
  <Isa style={{ color: "#D8000C", backgroundColor: "#FFD2D2" }} >
    <Isa_icon className="fa fa-times-circle" />
    {props.children}
  </Isa>
);
export const Isa_info = props => (
  <Isa style={{ color: "#00529B", backgroundColor: "#BDE5F8" }} >
    <Isa_icon className="fa fa-info-circle" />
    {props.children}
  </Isa>
);
export const Isa_success = props => (
  <Isa style={{ color: "#4F8A10", backgroundColor: "#DFF2BF" }} >
    <Isa_icon className="fa fa-times-check" />
    {props.children}
  </Isa>
);
export const Isa_warning = props => (
  <Isa style={{ color: "#9F6000", backgroundColor: "#FEEFB3" }} >
    <Isa_icon className="fa fa-times-warning" />
    {props.children}
  </Isa>
);



export const color1 = "#dd470c";
export const color2 = "#424264";
export const color3 = "rgb(238, 238, 238)";
export const hxOrange = "#ff8600";
// export const color4 = "#61bc7b";

export const Container = styled.div`
  height: 100vh;
  display: grid;
  grid-template-rows: ${props => props.Rows};
  grid-template-columns: ${props => props.Columns};
  grid-template-areas: ${props => props.Areas};
  font-family: adelle-sans, "Helvetica Neue", Helvetica, Arial, sans-serif;
  position: relative;
`;
// font-family: adelle-sans, "Helvetica Neue", Helvetica, Arial, sans-serif;
// font-family: Europa,"Avenir Next",Avenir,"Helvetica Neue",Helvetica,Arial,sans-serif;
export const Top = styled.div`
  grid-area: ${props => props.Area};
  background: ${color2};
  color: #fafafa;
`;

export const Center = styled.div`
  grid-area: ${props => props.Area};
  overflow-y: auto;
  background: ${color3};
  border-right: 1px solid #d0d0d0;
`;

export const Bottom = styled.div`
  grid-area: ${props => props.Area};
  background: ${color2};
  color: #fff;
  display: flex;
  justify-content: space-between;
`;

export const Left = styled.div`
  grid-area: ${props => props.Area};
  overflow-y: auto;
  background: ${color3};
`;
export const Right = styled.div`
  grid-area: ${props => props.Area};
  overflow-y: auto;
  background: rgb(224, 224, 224);
`;

export const SidebarContainer = styled.div`
  display: flex;
  flex-direction: column;
  grid-area: ${props => props.Area};
  overflow-y: auto;
  background: ${color3};
`;

export const TopbarContainer = styled.div`
  display: flex;
  flex-direction: row;
  grid-area: ${props => props.Area};
  overflow-x: auto;
`;

export const TopbarList = styled.div`
  display: flex;
  flex-direction: row;
`;

export const TopbarListItem = styled.div`
  text-align: left;
  color: #31436b;
  cursor: pointer;
  border-radius: 3px;
  padding: 5px;
  margin: 10px;
  transition: 0.2s ease all;
  &:first-child {
    border-top: none;
  }
  &:hover {
    color: #31436b;
    font-weight: bold;
  }
`;
export const TopbarGridItem = styled.div`
  text-align: left;
  cursor: pointer;
  color: rgba(0, 0, 0, 0.3);
  border-radius: 3px;
  margin: 10px;
  transition: 0.2s ease all;
  &:hover {
    color: rgba(0, 0, 0, 0.6);
  }
`;

export const LeftList = styled.ul``;
export const LeftListItem = styled.li`
  text-align: left;
  color: #31436b;
  cursor: pointer;
  border-radius: 3px;
  padding: 5px;
  margin: 10px;
  transition: 0.2s ease all;
  &:first-child {
    border-top: none;
  }
  &:hover {
    color: #31436b;
    font-weight: bold;
  }
`;
export const LeftListItemSelected = styled(LeftListItem)`
  background-color: ${color1};
  color: #fff;
  font-weight: bold;
  cursor: default;
  &:hover {
    background-color: ${color1};
    color: #fff;
    font-weight: bold;
    cursor: default;
  }
`;
export const LeftTooltip = styled.div`
  margin-top: 10px;
  margin-right: 10px;
  font-size: 13px;
  color: rgb(135, 125, 55);
  padding: 5px;
  background: rgb(255, 255, 204);
  border: 1px solid rgb(214, 214, 126);
  transition: opacity 0.2s ease;
`;

export const CenterList = styled.ul`
  display: flex;
  flex-wrap: wrap;
`;
// url(https://cloud.highcharts.com/images/abywon/0/136.svg);
export const CenterListItem = styled.li`
  width: 150px;
  height: 150px;
  background-image: ${props =>
    props.image ? "url(" + props.image + ")" : "none"};
  background-size: 100% 100%;
  background-color: #fff;
  border: 1px solid rgba(66, 66, 100, 0);
  margin: 0 3% 3% 0;
  box-shadow: 0 2px 5px #ddd;
  position: relative;
  div {
    display: block;
    background-color: rgba(66, 66, 100, 0.8);
    bottom: 0;
    width: 100%;
    line-height: 2em;
    border-radius: 0;
    position: absolute;
    font-size: 0.8em;
    color: #ffffff;
    text-align: center;
    z-index: 1;
    opacity: 0;
    transition: 0.2s ease all;
    opacity: 0;
    pointer-events: none;
  }
  &:hover {
    border: 5px solid rgba(66, 66, 100, 0.4);
    div {
      opacity: 1;
      pointer-events: auto;
    }
  }
`;

export const CenterListItemSelected = styled(CenterListItem)`
  border: 5px solid #a3edba;
`;

export const Output = styled.div`
  position: relative;
  background: white;
  height: 400px;
  width: 100%;
  box-shadow: 0 5px 10px #d5d5d5;
`;

export const Icon = styled.div`
  width: 20px;
  height: 20px;
  padding: 4px;
  position: absolute;
  top: 2px;
  left: 2px;
  margin: 4px;
  font-size: 16px;
  text-align: center;
  transform: rotate(-90deg);
  transition: 0.2s ease all;
  &:hover {
    color: ${color1};
  }
`;

export const StepperContainer = styled.div`
  grid-area: ${props => props.Area};
  background: ${color2};
  color: #fff;
  display: flex;
  justify-content: space-between;
  flex-direction: row;
`;

export const StepperItem = styled.div`
  position: relative;
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 10px;
  line-height: 50px;
  float: left;
  cursor: pointer;
  color: #a1a1b2;
  &:hover {
    color: #fff;
  }
`;
export const StepperItemLabel = styled.div`
  font-size: 15px;
  transition: 0.2s ease opacity;
`;

export const StepperItemBar = styled.div`
  top: 0;
  position: absolute;
  left: 0;
  width: 100%;
  height: 5px;
  background: ${color1};
  border-top: 1px solid #eee;
`;
export const StepperItemLeftBar = styled(StepperItemBar)`
  width: 51%;
  left: 51%;
`;

export const StepperItemRightBar = styled(StepperItemBar)`
  width: 51%;
  left: -1%;
`;

export const StepperItemBubble = styled.div`
  font-size: 0px;
  top: -6px;
  line-height: 25px;
  position: absolute;
  left: 50%;
  text-align: center;
  border-radius: 50%;
  transform: translate(-50%, 0);
  background-color: ${color1};
  color: #fff;
  width: 15px;
  height: 16px;
  border-top: 1px solid #eee;
  z-index: 2;
  transition: 0.2s ease all;
`;

export const StepperItemBubbleSelected = styled(StepperItemBubble)`
  font-size: 16px;
  top: -10px;
  height: 25px;
  width: 25px;
  bottom: -8px;
`;

export const BottomDirection = styled.div`
  line-height: 60px;
  width: 60px;
  height: 60px;
  text-align: center;
  background: rgba(255, 255, 255, 0.2);
  color: #fff;
  transition: 0.2s ease all;
  cursor: pointer;
  &:hover {
    background: ${color1} !important;
  }
`;

export const RightGroupList = styled.ul`
  display: flex;
  flex-direction: column;
  color: #31436b;
`;
export const RightGroup = styled.ul`
  margin: 15px 15px 40px 15px;
`;
export const RightGroupVertical = styled.ul`
  margin: 0 15px 0 15px;
`;

export const RightGroupHeader = styled.ul`
  margin-bottom: 0;
  padding-bottom: 15px;
  padding-left: 15px;
  padding-right: 15px;
  text-align: left;
  padding-top: 5px;
  color: #424242;
  font-weight: 600;
  font-family: "Roboto", sans-serif;
  font-size: 20px;
`;

export const RightGroupTable = styled.table`
  width: 100%;
`;

export const RightGroupTbody = styled.tbody`
  border: 1px solid #d5d5d5;
  box-shadow: 0 3px 7px #ddd;
`;

export const RightGroupTableTd = styled.td`
  padding: 10px;
  border-bottom: 1px solid #d5d5d5;
  font-family: Europa, "Avenir Next", Avenir, "Helvetica Neue", Helvetica, Arial,
    sans-serif;
`;
export const RightGroupTableTh = styled.th`
  text-align: left;
  font-weight: bold;
  color: #424242;
  padding: 10px;
  background-color: ${color3};
`;

export const FormTable = styled.table`
  border: 1px solid #d5d5d5;
  box-shadow: 0 3px 7px #ddd;
  width: 100%;
`;

export const FormTr = styled.tr`
  height: 30px;
  padding-top: 4px;
  padding-bottom: 4px;
  background: #f6f6f6;
`;

export const FormTd = styled.td`
  padding: 10px;
  border-bottom: 1px solid #d5d5d5;
  &:first-child {
    min-width: 30%;
    width: 30%;
    font-weight: 100;
    font-size: 14px;
  }
`;

export const Area = styled.div`
  grid-area: ${props => props.Area};
`;

export const FormHeader = styled.div`
  padding-bottom: 15px;
  padding-left: 15px;
  padding-right: 15px;
  text-align: left;
  padding-top: 5px;
  color: #424242;
  font-weight: bold;
  font-size: 20px;
`;

export const ReportHeader = styled.div`
  text-align: center;
  color: #424242;
  font-weight: bold;
  font-size: 20px;
  margin: auto;
`;

export const FormLabel = styled.span`
  font-weight: bold;
`;

export const FormInput = styled.input`
  outline: none;
  border: 1px solid #aaa;
  padding: 7px;
  font-size: 13px;
  min-height: 14px;
`;

export const FormInputText = styled(FormInput).attrs({
  type: "text"
})`
  width: 100%;
`;

export const FormInputCheck = styled(FormInput).attrs({
  type: "checkbox"
})`
  width: 20px;
`;

export const FormTextArea = styled.textarea`
  min-height: 75px;
  resize: vertical;
  max-width: 100%;
  width: 100%;
  padding: 5px 5px;
  border: 1px solid #d7d7d9;
  outline: none;
  background: #fff;
  border-radius: 3px;
  &:focus {
    border-color: #8c8c91;
  }
  box-sizing: border-box;
`;

export const FormIcon = styled.div`
  height: 32px;
  width: 32px;
  text-align: center;
  line-height: 32px;
  cursor: pointer;
  color: ${color2};
  &:hover {
    color: ${color1};
  }
`;

export const FormButton = styled.button`
    padding-left: 15px;
    padding-right: 15px;
    border: none;
    background: ${color2};
    color: #FFF;
    font-size: 12px;
    margin: 10px 15px 10px 0;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 1px;
    height: 30px;
    outline: none;
    cursor: pointer;
    transition: .2s ease all;
    &:hover {
      background: ${color1};
      color: #FFF;
    }
}`;

export const RightGroupTableTr = styled(FormTr)`
  background: ${props => (props.Selected ? "#e9e9e9!important" : "#f6f6f6")};
  &:nth-child(even) {
    background: #fff;
  }
  &:hover {
    background: #e9e9e9;
  }
  &:last-child td {
    border: none;
  }
`;

export const RightGroupTableTrSelected = styled(FormTr)`
  background-color: ${color2};
  color: #fff;
  font-weight: bold;
`;

const IconPicker = styled.div`
  position: absolute;
  width: 160px;
  height: 250px;
  padding: 5px 0;
  margin: 2px 0 0;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 3px;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
  z-index: 9999999990;
  background: white;
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  overflow-y: scroll;
`;

const SearchContainer = styled.div`
  margin-left: 4px;
  position: relative;
  &:after {
    color: #9d9d9d;
    font-family: "FontAwesome";
    content: "\\f128";
    font-size: 17px;
    font-weight: 400;
    font-variant: normal;
    text-transform: none;
    line-height: 1;
    -webkit-font-smoothing: antialiased;
    position: absolute;
    right: 10px;
    top: 8px;
  }
`;

const SearchInput = styled.input`
  display: block;
  width: 140px;
  height: 25px;
  padding: 4px;
  outline: none;
  border-radius: 2px;
  background: transparent;
  border: 1px solid #d7d7d9;
  &:focus {
    background: #fff;
    border-color: #8c8c91;
  }
`;

const iconls = [
  "address-book",
  "address-book-o",
  "address-card",
  "address-card-o",
  "adjust",
  "american-sign-language-interpreting",
  "anchor",
  "archive",
  "area-chart",
  "arrows",
  "arrows-h",
  "arrows-v",
  "asl-interpreting",
  "assistive-listening-systems",
  "asterisk",
  "at",
  "audio-description",
  "automobile",
  "balance-scale",
  "ban",
  "bank",
  "bar-chart",
  "bar-chart-o",
  "barcode",
  "bars",
  "bath",
  "bathtub",
  "battery",
  "battery-0",
  "battery-1",
  "battery-2",
  "battery-3",
  "battery-4",
  "battery-empty",
  "battery-full",
  "battery-half",
  "battery-quarter",
  "battery-three-quarters",
  "bed",
  "beer",
  "bell",
  "bell-o",
  "bell-slash",
  "bell-slash-o",
  "bicycle",
  "binoculars",
  "birthday-cake",
  "blind",
  "bluetooth",
  "bluetooth-b",
  "bolt",
  "bomb",
  "book",
  "bookmark",
  "bookmark-o",
  "braille",
  "briefcase",
  "bug",
  "building",
  "building-o",
  "bullhorn",
  "bullseye",
  "bus",
  "cab",
  "calculator",
  "calendar",
  "calendar-check-o",
  "calendar-minus-o",
  "calendar-o",
  "calendar-plus-o",
  "calendar-times-o",
  "camera",
  "camera-retro",
  "car",
  "caret-square-o-down",
  "caret-square-o-left",
  "caret-square-o-right",
  "caret-square-o-up",
  "cart-arrow-down",
  "cart-plus",
  "cc",
  "certificate",
  "check",
  "check-circle",
  "check-circle-o",
  "check-square",
  "check-square-o",
  "child",
  "circle",
  "circle-o",
  "circle-o-notch",
  "circle-thin",
  "clock-o",
  "clone",
  "close",
  "cloud",
  "cloud-download",
  "cloud-upload",
  "code",
  "code-fork",
  "coffee",
  "cog",
  "cogs",
  "comment",
  "comment-o",
  "commenting",
  "commenting-o",
  "comments",
  "comments-o",
  "compass",
  "copyright",
  "creative-commons",
  "credit-card",
  "credit-card-alt",
  "crop",
  "crosshairs",
  "cube",
  "cubes",
  "cutlery",
  "dashboard",
  "database",
  "deaf",
  "deafness",
  "desktop",
  "diamond",
  "dot-circle-o",
  "download",
  "drivers-license",
  "drivers-license-o",
  "edit",
  "ellipsis-h",
  "ellipsis-v",
  "envelope",
  "envelope-o",
  "envelope-open",
  "envelope-open-o",
  "envelope-square",
  "eraser",
  "exchange",
  "exclamation",
  "exclamation-circle",
  "exclamation-triangle",
  "external-link",
  "external-link-square",
  "eye",
  "eye-slash",
  "eyedropper",
  "fax",
  "feed",
  "female",
  "fighter-jet",
  "file-archive-o",
  "file-audio-o",
  "file-code-o",
  "file-excel-o",
  "file-image-o",
  "file-movie-o",
  "file-pdf-o",
  "file-photo-o",
  "file-picture-o",
  "file-powerpoint-o",
  "file-sound-o",
  "file-video-o",
  "file-word-o",
  "file-zip-o",
  "film",
  "filter",
  "fire",
  "fire-extinguisher",
  "flag",
  "flag-checkered",
  "flag-o",
  "flash",
  "flask",
  "folder",
  "folder-o",
  "folder-open",
  "folder-open-o",
  "frown-o",
  "futbol-o",
  "gamepad",
  "gavel",
  "gear",
  "gears",
  "gift",
  "glass",
  "globe",
  "graduation-cap",
  "group",
  "hand-grab-o",
  "hand-lizard-o",
  "hand-paper-o",
  "hand-peace-o",
  "hand-pointer-o",
  "hand-rock-o",
  "hand-scissors-o",
  "hand-spock-o",
  "hand-stop-o",
  "handshake-o",
  "hard-of-hearing",
  "hashtag",
  "hdd-o",
  "headphones",
  "heart",
  "heart-o",
  "heartbeat",
  "history",
  "home",
  "hotel",
  "hourglass",
  "hourglass-1",
  "hourglass-2",
  "hourglass-3",
  "hourglass-end",
  "hourglass-half",
  "hourglass-o",
  "hourglass-start",
  "i-cursor",
  "id-badge",
  "id-card",
  "id-card-o",
  "image",
  "inbox",
  "industry",
  "info",
  "info-circle",
  "institution",
  "key",
  "keyboard-o",
  "language",
  "laptop",
  "leaf",
  "legal",
  "lemon-o",
  "level-down",
  "level-up",
  "life-bouy",
  "life-buoy",
  "life-ring",
  "life-saver",
  "lightbulb-o",
  "line-chart",
  "location-arrow",
  "lock",
  "low-vision",
  "magic",
  "magnet",
  "mail-forward",
  "mail-reply",
  "mail-reply-all",
  "male",
  "map",
  "map-marker",
  "map-o",
  "map-pin",
  "map-signs",
  "meh-o",
  "microchip",
  "microphone",
  "microphone-slash",
  "minus",
  "minus-circle",
  "minus-square",
  "minus-square-o",
  "mobile",
  "mobile-phone",
  "money",
  "moon-o",
  "mortar-board",
  "motorcycle",
  "mouse-pointer",
  "music",
  "navicon",
  "newspaper-o",
  "object-group",
  "object-ungroup",
  "paint-brush",
  "paper-plane",
  "paper-plane-o",
  "paw",
  "pencil",
  "pencil-square",
  "pencil-square-o",
  "percent",
  "phone",
  "phone-square",
  "photo",
  "picture-o",
  "pie-chart",
  "plane",
  "plug",
  "plus",
  "plus-circle",
  "plus-square",
  "plus-square-o",
  "podcast",
  "power-off",
  "print",
  "puzzle-piece",
  "qrcode",
  "question",
  "question-circle",
  "question-circle-o",
  "quote-left",
  "quote-right",
  "random",
  "recycle",
  "refresh",
  "registered",
  "remove",
  "reorder",
  "reply",
  "reply-all",
  "retweet",
  "road",
  "rocket",
  "rss",
  "rss-square",
  "s15",
  "search",
  "search-minus",
  "search-plus",
  "send",
  "send-o",
  "server",
  "share",
  "share-alt",
  "share-alt-square",
  "share-square",
  "share-square-o",
  "shield",
  "ship",
  "shopping-bag",
  "shopping-basket",
  "shopping-cart",
  "shower",
  "sign-in",
  "sign-language",
  "sign-out",
  "signal",
  "signing",
  "sitemap",
  "sliders",
  "smile-o",
  "snowflake-o",
  "soccer-ball-o",
  "sort",
  "sort-alpha-asc",
  "sort-alpha-desc",
  "sort-amount-asc",
  "sort-amount-desc",
  "sort-asc",
  "sort-desc",
  "sort-down",
  "sort-numeric-asc",
  "sort-numeric-desc",
  "sort-up",
  "space-shuttle",
  "spinner",
  "spoon",
  "square",
  "square-o",
  "star",
  "star-half",
  "star-half-empty",
  "star-half-full",
  "star-half-o",
  "star-o",
  "sticky-note",
  "sticky-note-o",
  "street-view",
  "suitcase",
  "sun-o",
  "support",
  "tablet",
  "tachometer",
  "tag",
  "tags",
  "tasks",
  "taxi",
  "television",
  "terminal",
  "thermometer",
  "thermometer-0",
  "thermometer-1",
  "thermometer-2",
  "thermometer-3",
  "thermometer-4",
  "thermometer-empty",
  "thermometer-full",
  "thermometer-half",
  "thermometer-quarter",
  "thermometer-three-quarters",
  "thumb-tack",
  "thumbs-down",
  "thumbs-o-down",
  "thumbs-o-up",
  "thumbs-up",
  "ticket",
  "times",
  "times-circle",
  "times-circle-o",
  "times-rectangle",
  "times-rectangle-o",
  "tint",
  "toggle-down",
  "toggle-left",
  "toggle-off",
  "toggle-on",
  "toggle-right",
  "toggle-up",
  "trademark",
  "trash",
  "trash-o",
  "tree",
  "trophy",
  "truck",
  "tty",
  "tv",
  "umbrella",
  "universal-access",
  "university",
  "unlock",
  "unlock-alt",
  "unsorted",
  "upload",
  "user",
  "user-circle",
  "user-circle-o",
  "user-o",
  "user-plus",
  "user-secret",
  "user-times",
  "users",
  "vcard",
  "vcard-o",
  "video-camera",
  "volume-control-phone",
  "volume-down",
  "volume-off",
  "volume-up",
  "warning",
  "wheelchair",
  "wheelchair-alt",
  "wifi",
  "window-close",
  "window-close-o",
  "window-maximize",
  "window-minimize",
  "window-restore",
  "wrench"
];

export class Picker extends React.Component {
  constructor(props) {
    super(props);
    this.state = { list: iconls, isOpen: false };
  }

  filter(key) {
    this.setState(prevState => ({
      list: iconls.filter(str => str.includes(key))
    }));
  }

  toggle() {
    this.setState(prevState => ({
      isOpen: !prevState.isOpen
    }));
  }

  render() {
    return (
      <div>
        <span
          className={
            this.props.Icon ? `fa fa-${this.props.Icon}` : "fa fa-question"
          }
          style={{ margin: "5px" }}
        />
        <span
          className={this.state.isOpen ? "fa fa-caret-up" : "fa fa-caret-down"}
          style={{ margin: "5px", cursor: "pointer" }}
          onClick={e => {
            this.toggle();
          }}
        />
        {this.state.isOpen && (
          <div>
            <div
              style={{
                zIndex: 1000,
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0
              }}
              onClick={e => this.toggle()}
            />
            <IconPicker style={{ zIndex: 1001 }}>
              <SearchContainer>
                <SearchInput
                  type="text"
                  name="keyword"
                  onChange={e => this.filter(e.target.value)}
                />
              </SearchContainer>
              {this.state.list.map((icon, index) => (
                <span
                  key={index}
                  className={`fa fa-${icon}`}
                  title={icon}
                  style={{ margin: "5px", cursor: "pointer" }}
                  onClick={e => {
                    this.props.SetIcon(icon);
                    this.toggle();
                  }}
                />
              ))}
            </IconPicker>
          </div>
        )}
      </div>
    );
  }
}

export class Stepper extends React.Component {
  render() {
    return (
      <StepperContainer Area={this.props.Area}>
        <BottomDirection
          className="fa fa-arrow-left"
          onClick={() =>
            this.props.setStep(
              this.props.selectedStep ? this.props.selectedStep - 1 : 0
            )
          }
        />
        <div>
          {this.props.steps.map((step, index) => (
            <StepperItem key={index} onClick={() => this.props.setStep(index)}>
              <StepperItemLabel>{step.name}</StepperItemLabel>
              {index === 0 ? (
                <StepperItemLeftBar />
              ) : index === this.props.steps.length - 1 ? (
                <StepperItemRightBar />
              ) : (
                    <StepperItemBar />
                  )}
              {this.props.selectedStep === index ? (
                <StepperItemBubbleSelected>
                  {index + 1}
                </StepperItemBubbleSelected>
              ) : (
                  <StepperItemBubble />
                )}
            </StepperItem>
          ))}
        </div>
        <BottomDirection
          className="fa fa-arrow-right"
          onClick={() =>
            this.props.setStep(
              this.props.selectedStep < this.props.steps.length - 1
                ? this.props.selectedStep + 1
                : this.props.selectedStep
            )
          }
        />
      </StepperContainer>
    );
  }
}

export class Sidebar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedMenuItem: 0
    };
  }
  render() {
    return (
      <Left Area={this.props.Area}>
        <LeftList>
          {this.props.items.map(
            (item, index) =>
              index === this.state.selectedMenuItem ? (
                <LeftListItemSelected key={index}>
                  {item.name}
                </LeftListItemSelected>
              ) : (
                  <LeftListItem
                    key={index}
                    onClick={() =>
                      this.setState({
                        selectedMenuItem: index
                      })
                    }
                  >
                    {item.name}
                  </LeftListItem>
                )
          )}
        </LeftList>
      </Left>
    );
  }
}

export class QueryEditor extends React.Component {
  componentDidMount() {
    if (this.editor) {
      // this.editor.focus();

      // augment the built-in behavior of liveAutocomplete
      // built-in behavior only starts autocomplete when at least 1 character has been typed
      // In ace the . resets the prefix token and clears the completer
      // In order to get completions for 'sometable.' we need to fire the completer manually
      const editor = this.editor;
      editor.commands.on("afterExec", function (e) {
        if (e.command.name === "insertstring" && /^[\w.]$/.test(e.args)) {
          if (e.args === ".") {
            editor.execCommand("startAutocomplete");
          }
        }
      });
      if (this.props.config && this.props.config.editorWordWrap) {
        this.editor.session.setUseWrapMode(true);
      }
    }
    /*  Shortcuts
    ============================================================================== */
    // keymaster doesn't fire on input/textarea events by default
    // since we are only using command/ctrl shortcuts,
    // we want the event to fire all the time for any element
    keymaster.filter = function (event) {
      return true;
    };
    keymaster.unbind("ctrl+s, command+s");
    keymaster("ctrl+s, command+s", e => {
      this.saveQuery();
      e.preventDefault();
      return false;
    });
    // there should only ever be 1 QueryEditor on the page,
    // but just in case there isn't unbind anything previously bound
    // rather something previously not run than something run more than once
    keymaster.unbind("ctrl+r, command+r, ctrl+e, command+e");
    keymaster("ctrl+r, command+r, ctrl+e, command+e", e => {
      this.runQuery();
      e.preventDefault();
      return false;
    });
  }

  componentWillUnmount() {
    keymaster.unbind("ctrl+s, command+s");
    keymaster.unbind("ctrl+r, command+r, ctrl+e, command+e");
  }
  render() {
    return (
      <div style={{ margin: "10px", border: "1px solid #aaa" }}>
        <Editor
          mode="pgsql"
          theme="sqlserver"
          fontSize={14}
          name="query-editor"
          width="100%"
          height="calc(100vh - 235px)"
          showGutter={false}
          showPrintMargin={false}
          highlightActiveLine={false}
          onChange={result => this.props.SaveQuery(result)}
          value={this.props.Query}
          focus={true}
          ref={ref => {
            this.editor = ref ? ref.editor : null;
          }}
          editorProps={{ $blockScrolling: Infinity }}
          setOptions={{
            enableBasicAutocompletion: true,
            enableLiveAutocompletion: true,
            enableSnippets: false,
            showLineNumbers: true,
            tabSize: 2
          }}
        />
      </div>
    );
  }
}

const LogoLine = styled.div`
  position: relative;
`;

const Logo = styled.img`
  width: 130px;
  margin: 8px;
`;

const Loading = styled.img`
  position: absolute;
  top: 11px;
  left: 150px;
  width: 20px;
  display: ${props => (props.loading ? "inline" : "none")};
`;

const fullScreen = function () {
  if (document.documentElement.requestFullscreen) {
    document.documentElement.requestFullscreen();
  } else if (document.documentElement.msRequestFullscreen) {
    document.documentElement.msRequestFullscreen();
  } else if (document.documentElement.mozRequestFullScreen) {
    document.documentElement.mozRequestFullScreen();
  } else if (document.documentElement.webkitRequestFullscreen) {
    document.documentElement.webkitRequestFullscreen(
      Element.ALLOW_KEYBOARD_INPUT
    );
  }
};
const backToWindow = function () {
  if (document.exitFullscreen) {
    document.exitFullscreen();
  } else if (document.msExitFullscreen) {
    document.msExitFullscreen();
  } else if (document.mozCancelFullScreen) {
    document.mozCancelFullScreen();
  } else if (document.webkitExitFullscreen) {
    document.webkitExitFullscreen();
  }
};

export const Topbar = function (props) {
  const getComponent = key => {
    if (props.children) {
      // console.log(
      //   "getComponent: ",
      //   props.children.filter(comp => comp.props.position === key)
      // );
      return props.children.filter(comp => comp.props.position === key);
    }
  };
  const logOut = () => {
    localStorage.removeItem('id_token');
    window.location.href = '/login';
  };
  const calls = props.Session.Settings.withId(0).calls ? true : false;
  const isFullScreen = props.Session.Settings.withId(0).isFullScreen; //window.innerHeight == window.screen.height //
  return (
    <Top Area={props.Area}>
      <TopbarContainer
        style={{ justifyContent: "space-between", overflow: "hidden" }}
      >
        <TopbarList>{getComponent("onleft")}
          <LogoLine>
            <Logo src={logo_reverse} alt="logo" />
            <Loading src={loadingIcon} loading={calls} />
          </LogoLine>
        </TopbarList>
        <TopbarList>
          <a 
            href="https://musteri.hepsijet.com/new-ui/"
            style={{ 
              color: '#fff',
              fontSize: 15,
              padding: '0 32px',
              height: 28,
              background: '#ff6000',
              marginTop: 5,
              lineHeight: '26px',
              borderRadius: 4
            }}
          >
            Go to New UI
          </a>  
        </TopbarList>
        <TopbarList>
          {getComponent("onright")}
          <TopbarListItem
            style={{ color: "#FFF", padding: "0" }}
            onClick={() => {
              if (isFullScreen) {
                backToWindow();
                return props.upsert({
                  model: "Settings",
                  payload: {
                    isFullScreen: false,
                    id: 0
                  }
                });
              } else {
                fullScreen();
                return props.upsert({
                  model: "Settings",
                  payload: {
                    isFullScreen: true,
                    id: 0
                  }
                });
              }
            }}
            title={isFullScreen ? "Minimize" : "Full Screen"}
          >
            <span
              style={{ width: "25px" }}
              className={`fa fa-${isFullScreen ? "compress" : "expand"}`}
            />
          </TopbarListItem>
          <TopbarListItem
            style={{ color: "#FFF", padding: "0" }}
            onClick={() => logOut()}
            title={"Exit"}
          >
            <span style={{ width: "25px" }} className={`fa fa-sign-out`} />
          </TopbarListItem>
        </TopbarList>
      </TopbarContainer>
    </Top>
  );
};

export const filterTypes = [
  { label: "Select Type", value: "", disabled: true },
  { label: "Text", value: "Text" },
  { label: "Bool", value: "Bool" },
  { label: "Currency", value: "Currency" },
  { label: "Textarea", value: "Textarea" },
  { label: "Date", value: "Date" },
  { label: "Date Interval", value: "DateInterval" },
  { label: "Date Time", value: "DateTime" },
  { label: "Date Time Interval", value: "DateTimeInterval" },
  { label: "Date Week Of Month", value: "DateWeekOfMonth" },
  { label: "Select List", value: "SelectList" },
  { label: "Select Query", value: "SelectQuery" },
  { label: "Multi Select List", value: "MultiSelectList" },
  { label: "Multi Select Query", value: "MultiSelectQuery" }
];

export const headerTypes = [
  { label: "Select Type", value: "", disabled: true },
  { label: "Text", value: "Text" },
  { label: "Bool", value: "Bool" },
  { label: "Currency", value: "Currency" },
  { label: "Textarea", value: "Textarea" },
  { label: "Date", value: "Date" },
  { label: "Date Time", value: "DateTime" },
  { label: "List", value: "List" },
  { label: "Image", value: "Image" },
  { label: "SUM", value: "SUM" }
];

const filterVariables = [
  { label: "Select Variable", value: "", disabled: true },
  { label: "$1", value: "$1" },
  { label: "$2", value: "$2" },
  { label: "$3", value: "$3" },
  { label: "$4", value: "$4" },
  { label: "$5", value: "$5" },
  { label: "$6", value: "$6" },
  { label: "$7", value: "$7" },
  { label: "$8", value: "$8" },
  { label: "$9", value: "$9" },
  { label: "$10", value: "$10" },
  { label: "$11", value: "$11" },
  { label: "$12", value: "$12" },
  { label: "$13", value: "$13" },
  { label: "$14", value: "$14" },
  { label: "$15", value: "$15" }
];

// TODO: 
// value değerleri yanlış set ediliyor temel problem o...
export class FilterLine extends React.Component {
  render() {
    // const current = this.props.Session.RX_Report.withId(0).current;
    // const config = this.props.Session.RX_Report.withId(0).config;
    let item = this.props.item;
    let line = {};
    let filterName = (
      <FormTd style={{ width: "200px" }}>
        <FormInputText
          style={{ width: "calc(100% - 20px)" }}
          placeholder={"Filter Name"}
          value={item.label ? item.label : ""}
          name={item.label}
          onChange={e =>
            this.props.onChange({ ...item, label: e.target.value })
          }
        />
      </FormTd>
    );
    let filterType = (
      <FormTd style={{ width: "200px" }}>
        <Select
          value={item.type}
          options={filterTypes}
          onChange={result =>
            this.props.onChange({ ...item, type: result ? result.value: null, field: {} })
          }
        />
      </FormTd>
    );
    let filterField = (
      <FormTd style={{ width: "100px" }}>
        <Select
          value={item.field}
          options={filterVariables}
          onChange={result =>
            this.props.onChange({ ...item, field: result ? result.value : null })
          }
        />
      </FormTd>
    );
    let filterField1 = (
      <FormTd style={{ width: "100px" }}>
        <Select
          value={item.field.first}
          options={filterVariables}
          onChange={result =>
            this.props.onChange({
              ...item,
              field: { first: result ? result.value : null, second: item.field.second }
            })
          }
        />
      </FormTd>
    );
    let filterField2 = (
      <FormTd style={{ width: "100px" }}>
        <Select
          value={item.field.second}
          options={filterVariables}
          onChange={result =>
            this.props.onChange({
              ...item,
              field: { first: item.field.first, second: result.value }
            })
          }
        />
      </FormTd>
    );
    let filterOptions = (
      <FormTd style={{ width: "400px" }}>
        <FormInputText
          style={{ width: "calc(100% - 20px)" }}
          placeholder={
            "Example: [{label: Yes, value: true}, {label: No, value: false}]"
          }
          value={item.options || ''}
          onChange={e => this.props.onChange({ ...item, options: e.target.value })
          }
        />
      </FormTd>
    );
    let filterQuery = (
      <FormTd style={{ width: "400px" }}>
        <div style={{ position: "relative", width: "100%", height: "30px" }}>
          <Editor
            mode="pgsql"
            theme="sqlserver"
            fontSize={14}
            name="filter-query-editor"
            width="100%"
            height="100%"
            showGutter={false}
            showPrintMargin={false}
            highlightActiveLine={false}
            value={item.query && item.query.text ? item.query.text : ""}
            onChange={result =>
              this.props.onChange({ ...item, query: { text: result } })
            }
            ref={ref => {
              this["editor" + item.id] = ref ? ref.editor : null;
            }}
            editorProps={{ $blockScrolling: Infinity }}
            setOptions={{
              enableBasicAutocompletion: true,
              enableLiveAutocompletion: true,
              enableSnippets: false,
              showLineNumbers: true,
              tabSize: 2
            }}
          />
        </div>
      </FormTd>
    );
    let initQuery = (
      <FormTd style={{ width: "400px" }}>
        <div style={{ position: "relative", width: "100%", height: "30px" }}>
          <Editor
            mode="pgsql"
            theme="sqlserver"
            fontSize={14}
            name="filter-query-editor"
            width="100%"
            height="100%"
            showGutter={false}
            showPrintMargin={false}
            highlightActiveLine={false}
            value={
              item.initquery && item.initquery.text ? item.initquery.text : ""
            }
            onChange={result =>
              this.props.onChange({ ...item, initquery: { text: result } })
            }
            ref={ref => {
              this["editor" + item.id + "init"] = ref ? ref.editor : null;
            }}
            editorProps={{ $blockScrolling: Infinity }}
            setOptions={{
              enableBasicAutocompletion: true,
              enableLiveAutocompletion: true,
              enableSnippets: false,
              showLineNumbers: true,
              tabSize: 2
            }}
          />
        </div>
      </FormTd>
    );
    // let filterUndo = (
    //   <FormTd style={{ width: "30px" }}>
    //     <FormIcon className="fa fa-undo" onClick={() => this.props.undo()} />
    //   </FormTd>
    // );
    let filterRemove = (
      <FormTd style={{ width: "30px" }}>
        <FormIcon className="fa fa-times" onClick={() => this.props.remove()} />
      </FormTd>
    );
    switch (item.type) {
      case "Text":
      case "Textarea":
      case "SUM":
      case "Currency":
      case "Bool":
      case "Date":
      case "DateTime":
        line = (
          <FormTr>
            {filterName}
            {filterType}
            {filterField}
            {filterRemove}
          </FormTr>
        );
        break;
      case "DateInterval":
      case "DateTimeInterval":
      case "DateWeekOfMonth":
        line = (
          <FormTr>
            {filterName}
            {filterType}
            {filterField1}
            {filterField2}
            {filterRemove}
          </FormTr>
        );
        break;
      case "SelectList":
      case "MultiSelectList":
        line = (
          <FormTr>
            {filterName}
            {filterType}
            {filterField}
            {filterOptions}
            {filterRemove}
          </FormTr>
        );
        break;
      case "SelectQuery":
      case "MultiSelectQuery":
        line = (
          <FormTr>
            {filterName}
            {filterType}
            {filterField}
            {filterQuery}
            {initQuery}
            {filterRemove}
          </FormTr>
        );
        break;
      default:
        line = (
          <FormTr>
            <FormTd>
              <div />
            </FormTd>
          </FormTr>
        );
    }
    return line;
  }
}

export class HeaderLine extends React.Component {
  render() {
    // const current = this.props.Session.RX_Report.withId(0).current;
    // const config = this.props.Session.RX_Report.withId(0).config;
    let item = this.props.item;
    let line = {};
    let headerName = (
      <FormTd style={{ width: "200px" }}>
        <FormInputText
          style={{ width: "calc(100% - 20px)" }}
          placeholder={"Header Name"}
          value={item.label ? item.label : ""}
          name={item.label}
          onChange={e =>
            this.props.onChange({ ...item, label: e.target.value })
          }
        />
      </FormTd>
    );
    let headerType = (
      <FormTd style={{ width: "200px" }}>
        <Select
          value={item.type}
          options={headerTypes}
          onChange={result =>
            this.props.onChange({ ...item, type: result.value })
          }
        />
      </FormTd>
    );
    let headerField = (
      <FormTd style={{ width: "300px" }}>
        <FormInputText
          style={{ width: "calc(100% - 20px)" }}
          placeholder={"Header Name"}
          value={item.field ? item.field : ""}
          name={item.field}
          onChange={e =>
            this.props.onChange({ ...item, field: e.target.value })
          }
        />
      </FormTd>
    );
    let headerRemove = (
      <FormTd style={{ width: "30px" }}>
        <FormIcon className="fa fa-times" onClick={() => this.props.remove()} />
      </FormTd>
    );
    switch (item.type) {
      case "Text":
      case "Textarea":
      case "SUM":
      case "Currency":
      case "Bool":
      case "Date":
      case "DateTime":
      case "Image":
        line = (
          <FormTr>
            {headerName}
            {headerType}
            {headerField}
            {headerRemove}
          </FormTr>
        );
        break;
      case "List":
        line = (
          <FormTr>
            {headerName}
            {headerType}
            {headerField}
            {headerRemove}
            <Headers value={item} onChange={this.props.onChange} />
          </FormTr>
        );
        break;
      default:
        line = (
          <FormTr>
            <FormTd>
              <div />
            </FormTd>
          </FormTr>
        );
    }
    return line;
  }
}

const CustomComponent = forwardRef((props, ref) => {
  return <React.Fragment ref={ref}>{props.children}</React.Fragment>;
});

// <Headers value={?} onChange={?}  />
// "New", "Clone", "Update"  şimdilik bunlar var, daha sonra guncellenebilir...
export class Headers extends React.Component {
  state = {
    columns: this.props.value.browser && this.props.value.browser.columns ? this.props.value.browser.columns : []
  };
  
  render() {
    return (
      <div>
        <FormTable style={{ borderTop: "0" }}>
          <thead>
            <tr>
              <RightGroupTableTh>{"Name"}</RightGroupTableTh>
              <RightGroupTableTh>{"Type"}</RightGroupTableTh>
              <RightGroupTableTh>{"Column"}</RightGroupTableTh>
            </tr>
          </thead>
          <ReactSortable 
            tag="tbody" 
            list={this.props.value.browser && this.props.value.browser.columns ? this.props.value.browser.columns : []}
            setList={newState => 
              this.props.onChange(
                Object.assign({}, this.props.value, {
                  browser: { columns: newState }
                })
              )
            }
          >
            {this.props.value.browser &&  this.props.value.browser.columns.map((item, index) => (
              <HeaderLine
                onChange={value =>
                  this.props.onChange(
                    Object.assign({}, this.props.value, {
                      browser: {
                        columns: this.props.value.browser.columns.map(
                          (column, idx) => (index === idx ? value : column)
                        )
                      }
                    })
                  )
                }
                remove={() =>
                  this.props.onChange(
                    Object.assign({}, this.props.value, {
                      browser: {
                        columns: this.props.value.browser.columns.filter((column, idx) => index !== idx)
                      }
                    })
                  )
                }
                item={item}
                key={index}
              />
            ))}
          </ReactSortable>
        </FormTable>
        <FormButton
          onClick={() =>
            this.props.onChange(
              Object.assign({}, this.props.value, {
                browser: {
                  columns: [
                    ...this.props.value.browser.columns,
                    {
                      field: "",
                      type: "Text",
                      label: ""
                    }
                  ]
                }
              })
            )
          }
        >
          {"Add Header"}
        </FormButton>
      </div>
    );
  }
}

export const Tabs = styled.div`
  display: flex;
  justify-content: flex-start;
  background: #eee;
  color: #424264;
  height: 48px;
  font-weight: 300;
  font-size: 14px;
  line-height: 40px;
  padding: 5px;
  margin-bottom: 10px;
  overflow: hidden;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  cursor: default !important;
`;

export const Tab = styled.div`
  font-weight: 300;
  padding-left: 24px;
  padding-right: 24px;
  cursor: pointer;
  text-align: center;
`;

const TabIndicator = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 5px;
  background: #dd470c;
  transition: 0.2s ease all;
  -moz-transition: 0.2s ease all;
  -webkit-transition: 0.2s ease all;
`;

export const TabSelected = props => (
  <Tab style={{ position: "relative", fontWeight: "600" }}>
    {props.children}
    <TabIndicator />
  </Tab>
);

const getHeight = item => {
  let val = 0;
  if (item.type !== "List") {
    val = 0;
  } else {
    let arr = item.browser.columns.map(itm => 1 + getHeight(itm));
    val = Math.max(...arr);
  }
  // console.log("getHeight", val, item);
  return val;
};

const getSize = item => {
  if (item.type !== "List") {
    return 1;
  } else {
    return item.browser.columns.reduce(function (cumulator, itm) {
      // console.log("itm, getSize(itm)", itm, getSize(itm));
      return getSize(itm) + cumulator;
    }, 0);
  }
};

export const GetTableColumn = function (props) {
  let row = props.row;
  let item = props.item;
  let columns = [];
  switch (item.type) {
    case "Text":
      columns.push(
        <RightGroupTableTd key={props.index}>
          <div style={{ whiteSpace: "nowrap" }}> {row[item.field]}</div>
        </RightGroupTableTd>
      );
      break;
    case "SUM":
      columns.push(
        <RightGroupTableTd key={props.index}>
          <div style={{ whiteSpace: "nowrap" }}> {row[item.field]}</div>
        </RightGroupTableTd>
      );
      break;
    case "Bool":
      columns.push(
        <RightGroupTableTd key={props.index}>
          <div style={{ whiteSpace: "nowrap" }}> {"" + row[item.field]}</div>
        </RightGroupTableTd>
      );
      break;
    case "Currency":
      columns.push(
        <RightGroupTableTd key={props.index}>
          <NumberFormat
            renderText={value => (
              <div style={{ textAlign: "right" }}>{value}</div>
            )}
            value={row[item.field]}
            displayType={"text"}
            thousandSeparator={"."}
            decimalSeparator={","}
            decimalScale={2}
            fixedDecimalScale={true}
            suffix={"₺"}
          />
        </RightGroupTableTd>
      );
      break;
    case "Date":
      columns.push(
        <RightGroupTableTd key={props.index}>
          <div style={{ whiteSpace: "nowrap", fontFamily: "monospace" }}>
            {setClientDateFormat(row[item.field])}
          </div>
        </RightGroupTableTd>
      );
      break;
    case "DateTime":
      columns.push(
        <RightGroupTableTd key={props.index}>
          <div style={{ whiteSpace: "nowrap", fontFamily: "monospace" }}>
            {setClientDateTimeFormat(row[item.field])}
          </div>
        </RightGroupTableTd>
      );
      break;
    case "Image":
      columns.push(
        <RightGroupTableTd key={props.index}>
          {row[item.field] && (
            <img src={row[item.field]} height={"20"} width={"50"} />
          )}
        </RightGroupTableTd>
      );
      break;
    case "List":
      let subTable = row[item.field];
      subTable.map((subRow, subRowId) =>
        item.browser.columns.map((subitem, idx) => {
          let style = undefined;
          if (idx === 0) {
            style = { borderLeft: "1px solid #d5d5d5" };
          } else if (idx === item.browser.columns.length - 1) {
            style = { borderRight: "1px solid #d5d5d5" };
          }
          columns.push(
            <RightGroupTableTd
              key={props.index + "_" + subRowId + "_" + idx}
              style={style}
            >
              <div style={{ whiteSpace: "nowrap" }}>
                {subRow[subitem.field]}
              </div>
            </RightGroupTableTd>
          );
        })
      );
      break;
    default:
      columns.push(<RightGroupTableTd key={props.index} />);
  }
  return columns;
};

// const valueSetter = (str, values) => {
//   return str.template();
// };

// const valueSetter = new Function("str", "result", "return `" + "str" + "`;");

export const getTableHeadersAtHeight = (
  value,
  viewData,
  arr,
  height,
  style = undefined
) => {
  return value.browser.columns.map((item, item_idx) => {
    let currHeight = getHeight(item);
    let listLength =
      viewData && viewData[0] && viewData[0][item.field]
        ? viewData[0][item.field].length
        : 0;

    if (height === currHeight) {
      if (item.type !== "List") {
        let style = undefined;
        if (item_idx === 0) {
          style = { borderLeft: "1px solid #d5d5d5" };
        } else if (item_idx === value.browser.columns.length - 1) {
          style = { borderRight: "1px solid #d5d5d5" };
        }
        arr.push({ style, label: item.label, col: getSize(item) });
      } else {
        for (let i = 0; i < listLength; i++) {
          let style = undefined;
          if (i === 0) {
            style = { borderLeft: "1px solid #d5d5d5" };
          } else if (i === listLength - 1) {
            style = { borderRight: "1px solid #d5d5d5" };
          }
          arr.push({
            style: style,
            // label: valueSetter(item.label, viewData[0][item.field][i]),
            label: new Function("result", "return `" + item.label + "`;")(
              viewData[0][item.field][i]
            ),
            col: getSize(item)
          });
        }
      }
    } else if (item.type === "List") {
      for (let i = 0; i < listLength; i++) {
        // let style = undefined;
        // if (i === 0) {
        //   style = { borderLeft: "5px solid #d5d5d5" };
        // } else if (i === listLength - 1) {
        //   style = { borderRight: "5px solid #d5d5d5" };
        // }
        getTableHeadersAtHeight(
          item,
          viewData && viewData[0] && viewData[0][item.field]
            ? viewData[0][item.field]
            : undefined,
          arr,
          height
        );
      }
    } else {
      arr.push({ label: "", col: 1 });
    }
  });
};

export const getHeaders = props => {
  var treeHeight = Math.max(...props.value.browser.columns.map(getHeight), 0);
  let headerArray = Array(treeHeight + 1)
    .fill(0)
    .map(itm => []);
  // headerArray = headerArray.map(itm => []);
  // console.log("headerArray:", headerArray);
  headerArray.map((arr, index) =>
    getTableHeadersAtHeight(props.value, props.viewData, arr, index)
  );
  // console.log("headerArray:", headerArray);
  headerArray = headerArray.reverse();
  return headerArray;
};

// export const TableHeaderView = function(props) {
//   let headerArray = getHeaders(props);
//   return (
//     <thead>
//       {headerArray.map((arr, index) => (
//         <tr key={"header_" + index}>
//           {arr.map((header, idx) => (
//             <RightGroupTableTh
//               style={header.style}
//               key={idx}
//               colSpan={`${header.col}`}
//             >
//               {header.label}
//             </RightGroupTableTh>
//           ))}
//         </tr>
//       ))}
//     </thead>
//   );
// };

// export class TableBodyView extends React.Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       selected: undefined
//     };
//   }
//   render() {
//     return (
//       <RightGroupTbody>
//         {this.props.viewData.map((row, index) => {
//           let BaseComponent =
//             this.state.selected === index
//               ? RightGroupTableTrSelected
//               : RightGroupTableTr;
//           return (
//             <BaseComponent
//               key={"body_" + index}
//               onClick={() =>
//                 this.setState({
//                   selected: index
//                 })}
//             >
//               {this.props.value.browser.columns.map((item, idx) =>
//                 GetTableColumn({ row, item, index: index + "_" + idx })
//               )}
//             </BaseComponent>
//           );
//         })}
//       </RightGroupTbody>
//     );
//   }
// }

export class TableView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: new Set()
    };
  }
  render() {
    let config = this.props.value.browser;
    if (!config) return <div />;

    let headerArray = getHeaders(this.props);
    // console.log("headerArray:", headerArray);
    let bodyView = <FormTr><FormTd><Isa_warning>
      {"Undefined Error: Please report this issue to IT"}
    </Isa_warning></FormTd></FormTr>
    if (!Array.isArray(this.props.viewData)) {
      if (this.props.viewData && this.props.viewData.message) {
        bodyView = <FormTr>
          <FormTd><Isa_error>{this.props.viewData.message.code}</Isa_error></FormTd>
          <FormTd>{this.props.viewData.message.routine}</FormTd>
          <FormTd>{this.props.viewData.message.hint}</FormTd>
        </FormTr>
      }
    } else {
      bodyView = this.props.viewData.map((row, index) => {
        let BaseComponent = this.state.selected.has(index)
          ? RightGroupTableTrSelected
          : RightGroupTableTr;
        return (
          <BaseComponent
            key={"body_" + index}
            onClick={() => {
              this.state.selected.has(index)
                ? this.state.selected.delete(index)
                : this.state.selected.add(index);
              this.setState({
                selected: this.state.selected
              });
            }}
          >
            {this.props.value.browser.columns.map((item, idx) =>
              GetTableColumn({ row, item, index: index + "_" + idx })
            )}
          </BaseComponent>
        );
      });
    }
    return (
      <div>
        <FixedHtmlTable
          width="calc(100vw - 250px)"
          height="calc(100vh - 165px)"
        >
          <RightGroupTable>
            <thead>
              {headerArray.map((arr, index) => (
                <tr key={"header_" + index}>
                  {arr.map((header, idx) => (
                    <RightGroupTableTh
                      style={header.style}
                      key={idx}
                      colSpan={`${header.col}`}
                    >
                      {header.label}
                    </RightGroupTableTh>
                  ))}
                </tr>
              ))}
            </thead>
            <RightGroupTbody>{bodyView}</RightGroupTbody>
          </RightGroupTable>
        </FixedHtmlTable>
      </div>
    );
  }
}

// <RightGroupTable>
//   <TableHeaderView {...props} />
//   <TableBodyView {...props} />
// </RightGroupTable>

// parseInt(currentDate.date() / 7 + 1)
export const DatetimeRenderers = {
  renderDay: function (props, currentDate, selectedDate) {
    if (currentDate.date() % 7 === 1) {
      let start = currentDate.date();
      let end = currentDate.endOf("month").date();
      end = start + 6 < end ? start + 6 : end;
      return (
        <td style={{ whiteSpace: "nowrap" }} {...props}>
          {"" + start + "-" + end}
        </td>
      );
    }
  },
  renderMonth: function (props, month, year, selectedDate) {
    return <td {...props}>{month}</td>;
  },
  renderYear: function (props, year, selectedDate) {
    return <td {...props}>{year % 100}</td>;
  },
  renderInput: function (props, openCalendar) {
    function clear() {
      props.onChange({ target: { value: "" } });
    }
    return (
      <div>
        <button onClick={openCalendar}>open calendar</button>
        <input {...props} style={{ borderColor: "green" }} />
        <label> Deneme </label>
        <button onClick={clear}>clear</button>
      </div>
    );
  }
};

const ModalContainer = styled.div`
  display: ${props =>
    props.isOpen ? "block" : "none"}; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 1; /* Sit on top */
  padding-top: 100px; /* Location of the box */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
`;

const ModalContent = styled.div`
  display: ${props =>
    props.isOpen ? "block" : "none"}; /* Hidden by default */
  position: fixed; /* Stay in place */
  background-color: rgb(238, 238, 238); /* #fefefe; */
  z-index: 2; /* Sit on top */
  left: 10%;
  top: 10%;
  margin: auto;
  padding: 20px;
  border: 1px solid #888;
  width: 80%;
`;

const ModalClose = styled.div`
  color: #aaaaaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
  &:hover {
    color: #000;
    text-decoration: none;
    cursor: pointer;
  }
  &:focus {
    color: #000;
    text-decoration: none;
    cursor: pointer;
  }
`;

export class Modal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false
    };
  }
  toggle() {
    this.setState(prevState => ({
      isOpen: !prevState.isOpen
    }));
  }
  render() {
    return (
      <div>
        <FormButton
          onClick={e => this.toggle()}
          style={{ width: "160px", margin: "5px" }}
        >
          {"Filter Columns"}
        </FormButton>
        <ModalContainer
          onClick={e => this.toggle()}
          isOpen={this.state.isOpen}
        />
        <ModalContent isOpen={this.state.isOpen}>
          <ModalClose onClick={e => this.toggle()}>&times;</ModalClose>
          {this.props.children}
        </ModalContent>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Base.js